import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ConfirmationService } from 'primeng/api';
import { tap } from 'rxjs/operators';
import { IError } from 'src/app/models/ierror.interface';
import { PersonRegistrationResource } from 'src/app/models/iregistration.interface';
import { MessageToastService } from 'src/app/services/common/message-toast.service';
import { RegService } from 'src/app/services/data/reg.service';

@UntilDestroy()
@Component({
  selector: 'app-person-conference-certificate-view',
  templateUrl: './person-conference-certificate-view.component.html',
  styleUrls: ['./person-conference-certificate-view.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonConferenceCertificateViewComponent implements OnInit {
  @Input() data: PersonRegistrationResource;
  @Input() isReadOnly: boolean = true;
  @Output() print = new EventEmitter<boolean>();
  @Output() send = new EventEmitter<boolean>();
  @Output() updated = new EventEmitter<boolean>();

  constructor(
    private _reg: RegService,
    private _msg: MessageToastService,
    private _confirm: ConfirmationService,
  ) { }

  ngOnInit(): void {
  }

  onSetMark() {
    this._reg.setMark(this.data.conferenceId, this.data.personId).pipe(
      untilDestroyed(this),
      tap((data: PersonRegistrationResource) => {
        this._msg.success('Отметка проставлена');
        this.updated.emit(true);
      })
    ).subscribe();
  }

  onCert(val: boolean) {
    if (val == true) {
      this._reg.setCertificate(this.data.conferenceId, this.data.personId).pipe(
        untilDestroyed(this),
        tap((data: PersonRegistrationResource) => {
          this._msg.success('Код НМО проставлен');
          this.updated.emit(true);
        })
      ).subscribe();
    } else {
      this._reg.deleteCertificate(this.data.conferenceId, this.data.personId).pipe(
        untilDestroyed(this),
        tap((data: PersonRegistrationResource) => {
          this._msg.success('Код НМО удален');
          this.updated.emit(true);
        })
      ).subscribe();
    }
  }
  onPrint() {
    this._reg.pdfNmo(this.data.id).pipe(
      untilDestroyed(this),
      tap((res) => {
        const fileURL = URL.createObjectURL(res);
        window.open(fileURL, '_blank');
      })
    ).subscribe();
  }

  onSend()  {
    this._confirm.confirm({
      message: `Вы действительно хотите отправить сертификат?`,
      accept: () => {
        this._reg.sendNmo(this.data.id).pipe(
          untilDestroyed(this),
          tap((res: IError) => {
            this._msg.success(res.message);
          }),
        ).subscribe();
      },
      reject: () => { }
    });
  }
}
